import { SearchInfoPagination, SearchInfoWrapper } from "../../storyV2/model/SearchInfoWrapper";
import { FuncResponse, FuncResponseType, FunctionBase } from "./FunctionBase";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
export class WeeeShoppingFunction extends FunctionBase {
    async run(input, identityInfo, variableList = [], page = 1) {
        const res = await this.getWeeeShoppingInfo(input, page, FunctionUtil.createAbortUuid(identityInfo));
        const pagination = new SearchInfoPagination(res?.pagination?.page || page, res?.pagination?.totalPage);
        const searchInfoWrapper = new SearchInfoWrapper(input, pagination, res?.items || [], res?.source);
        return new FuncResponse(FuncResponseType.WEEE_SHOPPING, searchInfoWrapper);
    }
    async getWeeeShoppingInfo(query, page, uuid) {
        const result = await this.brainClient.openAi.getWeeeShoppingInfo(query, page, uuid);
        return result?.data?.data;
    }
}
